import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import logo from "../../../../../assets/icons/logo_lg.png"
import "./styles.css";

function Header() {
  return (
    <Navbar expand="md" bg="dark" variant="dark">
      <Navbar.Brand as={Link} to="/">
      <img
        alt="Logo"
        src={logo}
        width="28"
        height="28"
        style={{borderRadius:"20px"}}
        className="d-inline-block align-top mr-2"
      />
        CR21
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav
          className="ml-3 mr-auto text-light"
        >
          <Nav.Link
            as={Link}
            to="/location-resources"
            eventKey="/location-resources"
            className={`bg-dark text-light pl-2 pr-2`}
          >
            Location Resources
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/track"
            eventKey="/track"
            className="bg-dark text-light pl-2 pr-2"
          >
            Live Bed Tracker
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/key-resources"
            eventKey="/key-resources"
            className=" bg-dark text-light pl-2 pr-2"
          >
            Important Links
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/remedies"
            eventKey="/remedies"
            className=" bg-dark text-light pl-2 pr-2"
          >
            Home Therapy
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/stories"
            eventKey="/stories"
            className=" bg-dark text-light pl-2 pr-2"
          >
            Stories
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/help"
            eventKey="/help"
            className="bg-dark text-light pl-2 pr-2"
            title="How To?"
          >
            <i className="fas fa-question"></i>
          </Nav.Link>
        </Nav>
        <Nav.Link
            as={Link}
            to="/about"
            eventKey="/about"
            className=" bg-dark text-light ml-auto"
          >
            About Us
          </Nav.Link>
        {/* <Nav.Link
          href="mailto:covidresourcesr21@gmail.com"
          className="text-light ml-auto"
        >
          contact@cr21.ml
        </Nav.Link> */}
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Header;
